import { FormControl } from '@chakra-ui/react';
import { useClassFiltersStore } from '@stores/classes';
import { Select } from 'chakra-react-select';
import { ChakraStylesConfig } from 'chakra-react-select';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface ClassTypeOption {
  value: string;
  label: string;
}

const classTypeOptions: ClassTypeOption[] = [
  { value: 'yoga', label: 'Yoga' },
  { value: 'pilates', label: 'Pilates' },
  { value: 'reformer', label: 'Reformer' },
];

export function RiiseFilter() {
  const classType = useClassFiltersStore((state) => state.classType);
  const setClassType = useClassFiltersStore((state) => state.setClassType);
  const location = useLocation();
  const navigate = useNavigate();

  // Vérifier si l'URL contient un type de cours et le définir
  useEffect(() => {
    const coursMatch = location.pathname.match(/\/cours\/([^/]+)(?:$|\/)/);
    if (coursMatch) {
      const courseType = coursMatch[1];
      if (classTypeOptions.some((option) => option.value === courseType)) {
        setClassType([courseType]);
        // Nettoyer l'URL en préservant le studio s'il existe
        const studioMatch = location.pathname.match(/\/studio\/(\d+)/);
        const newPath = studioMatch ? `/studio/${studioMatch[1]}` : '/';
        navigate(newPath, { replace: true });
      }
    }
  }, [location.pathname, setClassType, navigate]);

  // Ne pas afficher le filtre si on n'est pas dans le contexte Riise
  if (!mondayMindbody?.siteId || mondayMindbody.siteId !== '5736555') {
    return null;
  }

  const chakraStyles: ChakraStylesConfig<ClassTypeOption, true> = {
    container: (provided) => ({
      ...provided,
      minWidth: '200px',
    }),
    control: (provided) => ({
      ...provided,
      backgroundColor: 'white',
      borderColor: 'gray.200',
      _hover: {
        borderColor: 'primary.500',
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? 'primary.500' : 'white',
      color: state.isSelected ? 'white' : 'gray.700',
      _hover: {
        backgroundColor: state.isSelected ? 'primary.600' : 'gray.100',
      },
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: 'primary.100',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: 'primary.700',
    }),
  };

  return (
    <FormControl>
      <Select<ClassTypeOption, true>
        size="sm"
        isMulti
        name="classType"
        options={classTypeOptions}
        placeholder="Type de cours"
        value={classTypeOptions.filter((option) => (classType || []).includes(option.value))}
        onChange={(options) => setClassType(options ? options.map((option) => option.value) : [])}
        closeMenuOnSelect={false}
        chakraStyles={chakraStyles}
      />
    </FormControl>
  );
}
